import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { isUnsavedSelector } from '../selectors'

export function useIsUnsaved() {
  return useSelector<RootState, boolean>(isUnsavedSelector)
}
